module.exports = __webpack_public_path__ + "img/StyleQueryS1Page.e320635d.png";